import { trackAnalyticsCustomEvent } from '@ifixit/analytics';
import { onDomReady } from 'Shared/utils/dom-ready';

onDomReady(() => {
   HeaderLanguages.initialize();
});

const HeaderLanguages = {
   initialize: function () {
      document.querySelectorAll('.language-option').forEach(option => {
         option.addEventListener('click', ev => {
            const form = option.closest('form');
            const newLangid = option.dataset.langid;

            if (newLangid) {
               form.querySelectorAll(':scope > .langidInput').forEach(input => {
                  input.value = newLangid;
               });
            }

            form.submit();

            if (!App.canIBypassGAEventFiringOnMobile && App.lang != newLangid) {
               trackAnalyticsCustomEvent({
                  eventCategory: 'Language',
                  eventAction: `Language Switcher - ${App.lang} - ${newLangid}`,
               });
            }

            ev.preventDefault();
            ev.stopPropagation();
         });
      });
   },
};
